module.exports = __webpack_public_path__ + "static/img/growup-ad.27c1838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/growup-ad.png
// module id = MC5z
// module chunks = 0